import type { WorkshopStatusValue } from '@workshop-hst/shared';

const styles: Record<WorkshopStatusValue, { bg: string; text: string; label: string; dot: string }> = {
  draft: { bg: '#F0F0EC', text: '#525252', label: 'Draft', dot: '#9CA09C' },
  scheduled: { bg: '#E0F2E9', text: '#0B5132', label: 'Scheduled', dot: '#0B5132' },
  live: { bg: '#FFE2DA', text: '#7A2208', label: 'Live now', dot: '#E94B1A' },
  completed: { bg: '#E1EAFD', text: '#1E3A8A', label: 'Completed', dot: '#1E3A8A' },
  canceled: { bg: '#F5E0E0', text: '#7A1C1C', label: 'Canceled', dot: '#7A1C1C' },
};

export function StatusPill({ status }: { status: WorkshopStatusValue }) {
  const s = styles[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-tight"
      style={{ background: s.bg, color: s.text }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.dot }} />
      {s.label}
    </span>
  );
}
